module.exports = __webpack_public_path__ + "img/Italy.982a555e.png";